<template>
    <div>
        <div class="card mb-3" id="bank-list">
            <div class="card-header headline bank">
                <h2 class="text-white d-inline">بانک</h2>
                <button class="btn btn-secondary float-left" data-toggle="modal" data-target="#bank-modal"
                        @click="onModalButtonClicked">افزودن حساب بانکی
                </button>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-12 mb-3">
                        <input type="text" class="form-control" placeholder="جستجو..." @input="onSearchInput"
                               v-model="searchString">
                    </div>
                    <div class="col-lg-12 mt-5" v-if="banks.length < 1">
                        <h3 class="text-center no-item-alert">حسابی ثبت نشده است!</h3>
                    </div>
                    <div class="col-lg-3 mb-3" v-for="(item, index) in banks">
                        <div class="card shadow" @click="onCardClicked(index)">
                            <div class="row p-2">
                                <!--<div class="col-lg-12">-->
                                <!--<img src="../../assets/img/placeholder.png" class="img-fluid w-100">-->
                                <!--</div>-->
                                <div class="col-lg-12 mt-3">
                                    <h4 class="text-center">{{item.outSourceName}}</h4>
                                    <h4 class="text-center text-success">شماره حساب: {{item.accountNumber}}</h4>
                                    <h4 class="text-center text-success">شماره کارت:{{item.kartNumber}}</h4>
                                    <span>توضیحات: </span>
                                    <span>{{item.description}}</span>
                                    <br>
                                    <span>مانده: </span>
                                    <span>{{item.remain<0 ? "(" + (item.remain*-1).toLocaleString() +"-)": item.remain.toLocaleString()}}</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!--<div v-if="banks.length > 7 && lastRespond.length > 7" class="col-lg-12 text-center mb-3" @click="getBanks">
                        <button class="btn btn-success">نمایش حساب های بیشتر</button>
                    </div>-->
                    <div class="col-lg-12">
                        <div class="sk-circle" id="loading">
                            <div class="sk-circle1 sk-child"></div>
                            <div class="sk-circle2 sk-child"></div>
                            <div class="sk-circle3 sk-child"></div>
                            <div class="sk-circle4 sk-child"></div>
                            <div class="sk-circle5 sk-child"></div>
                            <div class="sk-circle6 sk-child"></div>
                            <div class="sk-circle7 sk-child"></div>
                            <div class="sk-circle8 sk-child"></div>
                            <div class="sk-circle9 sk-child"></div>
                            <div class="sk-circle10 sk-child"></div>
                            <div class="sk-circle11 sk-child"></div>
                            <div class="sk-circle12 sk-child"></div>
                        </div>
                    </div>
                    <div v-if="!autoload && banks.length < dataCount" class="col-lg-12 text-center mb-3"
                         @click="getBanks">
                        <button class="btn btn-success">نمایش موارد بیشتر</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="bank-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 v-if="params.mode === 'create'" class="modal-title text-white">افزودن حساب بانکی</h5>
                        <h5 v-if="params.mode === 'edit'" class="modal-title text-white">ویرایش حساب بانکی</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-lg-6 offset-lg-3 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نام بانک</span>
                                    </div>
                                    <vs-select :data="bankList" :selected-val="preselectedBank" :mode="'create'"
                                               :header="{multiple: false, label: 'name'}"
                                               @onChange="onBankChange"></vs-select>
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">شعبه</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="bank.branchName">
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">صاحب حساب</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="bank.branchCode">
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">شماره کارت</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="bank.kartNumber">
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">شماره شبا</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="bank.shebaCode">
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نوع حساب</span>
                                    </div>
                                    <vs-select :data="accountTypes" :selected-val="preselectedAccountType"
                                               :mode="'create'"
                                               :header="{multiple: false, label: 'name'}"
                                               @onChange="onAccountTypeChange"></vs-select>
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">شماره حساب</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="bank.accountNumber">
                                </div>
                            </div>
                        </div>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text">توضیحات</span>
                            </div>
                            <input class="form-control" type="text" v-model="bank.description">
                        </div>
                    </div>
                    <div class="modal-footer d-block">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-danger mr-2" v-if="params.mode === 'edit'" @click="deleteItem()">حذف</button>
                        <button v-if="params.mode === 'edit'" type="button" class="btn btn-success mr-2"
                                data-dismiss="modal" @click="onTransactionModalClicked">گردش حساب
                        </button>
                        <button type="button" class="btn btn-primary m-0" @click="onModalOk">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="transactionModal" tabindex="-1" role="dialog" aria-labelledby="transactionTitle"
             aria-hidden="true" style="overflow-y: scroll">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-danger-grad glow-danger">
                        <h5 class="modal-title text-white" id="transactionTitle">گردش حساب</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row" v-if="listView">
                            <div class="col-lg-12" v-for="(item, index) in transactions">
                                <div class="card list" @click="onCardClicked($event, index)">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <strong>{{item.factor}}</strong>
                                        </div>
                                        <div class="col-md-3">
                                            <strong>حساب: </strong>
                                            <span>{{item.account}}</span>
                                        </div>
                                        <div class="col-md-3">
                                            <strong>مبلغ: </strong>
                                            <span v-if="item.creditor === 0 && item.debtor !== 0" class="text-success">{{item.debtor}} +</span>
                                            <span v-if="item.debtor === 0 && item.creditor !== 0" class="text-danger">{{item.creditor}} -</span>
                                        </div>
                                        <div class="col-md-3">
                                            <strong>تاریخ: </strong>
                                            <span>{{item.persianDate}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-lg-6 product-container" v-for="(item, index) in transactions">
                                <div class="card transaction mt-2 mb-2" @click="onCardClicked($event, index)">
                                    <div class="card-header">
                                        <h4 class="text-center">{{item.factor}}</h4>
                                    </div>
                                    <div class="card-body">
                                        <span><b>حساب: </b></span>
                                        <span>{{item.account}}</span>
                                        <br>
                                        <span><b>توضیحات: </b></span>
                                        <span>{{item.description}}</span>
                                        <br>
                                        <span><b>تاریخ: </b></span>
                                        <span>{{item.persianDate}}</span>
                                        <br>
                                        <div class="text-center">
                                            <h5 class="d-inline">مبلغ: </h5>
                                            <h5 v-if="item.creditor === 0 && item.debtor !== 0"
                                                class="text-success d-inline">{{item.debtor}}</h5>
                                            <h5 v-if="item.debtor === 0 && item.creditor !== 0"
                                                class="text-danger d-inline">{{item.creditor}}</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-lg-12 text-center">
                                <div v-if="transactions === undefined || transactions.length < 1" class="col-lg-12">
                                    <h3 class="no-item-alert text-center">رکوردی یافت نشد!</h3>
                                </div>
                                <div v-if="transactions !== undefined && transactions.length < transactionCount"
                                     class="col-lg-12 text-center" @click="getTransactions">
                                    <button class="btn btn-success">نمایش موارد بیشتر</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer d-block">
                        <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import VsSelect from "../../_framework/VsSelect";
    import EventBus from "../../_framework/event-bus.js";
    import Moment from "moment-jalali";

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'bank',
        components: {VsSelect},
        data() {
            return {
                banks: [],
                queryParams: {
                    pageSize: 10000,
                    pageIndex: 0,
                    name: "",
                    types: 1
                },
                preselectedBank: {},
                preselectedAccountType: {},
                bank: {
                    branchName: "",
                    branchCode: "",
                    kartNumber: "",
                    shebaCode: "",
                    accountType: "",
                    accountNumber: "",
                    description: "",
                    outSourceName: "بانک",
                    accountOwner: "",
                    type: 1
                },
                bankList: [
                    {name: "کشاورزی"},
                    {name: "انصار"},
                    {name: "آینده"},
                    {name: "بانک مرکزی"},
                    {name: "بانک شهر"},
                    {name: "دی"},
                    {name: "اقتصاد نوین"},
                    {name: "گردشگری"},
                    {name: "قوامین"},
                    {name: "کارافرین"},
                    {name: "مسکن"},
                    {name: "مهر"},
                    {name: "ملت"},
                    {name: "ملی"},
                    {name: "پارسیان"},
                    {name: "پاسارگاد"},
                    {name: "پست بانک"},
                    {name: "رفاه"},
                    {name: "رسالت"},
                    {name: "صادرات"},
                    {name: "صنعت و معدن"},
                    {name: "سامان"},
                    {name: "سپه"},
                    {name: "سینا"},
                    {name: "تجارت"},
                    {name: "سرمایه"},
                ],
                accountTypes: [
                    {
                        id: 1,
                        name: "جاری"
                    },
                    {
                        id: 2,
                        name: "قرض الحسنه"
                    },
                    {
                        id: 3,
                        name: "سپرده"
                    },
                    {
                        id: 4,
                        name: "تسهیلات"
                    }
                ],
                params: {
                    mode: 'create'
                },
                searchString: "",

                transactions: [],
                listView: true,
                transactionsQuery: {
                    pageSize: 8,
                    pageIndex: 0,
                    code: 0
                },
                dataCount: 0,
                transactionCount: 0,

                autoload: false,
                isSending: false,
                provider: {
                    phoneNumber: "",
                    description: "",
                    outSourceName: "",
                    type: 1
                },
            }
        },
        mounted() {
            this.autoload = JSON.parse(localStorage.getItem("autoload"));
            this.listView = JSON.parse(localStorage.getItem("listView"));
            EventBus.$on('listView', value => {
                this.listView = value;
            });
            new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                this.banks = response.data.data;
                this.dataCount = response.data.count;
                $("#loading").hide();
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.message, this.$noty);
            });

            if (JSON.parse(localStorage.getItem("autoload"))) {
                $(window).on("scroll", () => {
                    if (Utils.onBottomReached() && this.banks.length < this.dataCount) {
                        $("#loading").show();
                        this.getBanks();
                    }
                });
            }
        },
        methods: {
            getBanks() {
                this.queryParams.pageIndex++;
                $("#loading").show();
                new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                    this.banks.push.apply(this.banks, response.data.data);
                    this.lastRespond = response.data.data;
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onSearchInput() {
                this.queryParams.name = this.searchString;
                this.queryParams.pageIndex = 0;
                $("#loading").show();
                new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                    this.banks = response.data.data;
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onCardClicked(index) {
                this.params.mode = 'edit';
                this.bank = JSON.parse(JSON.stringify(this.banks[index]));
                for (let item of this.bankList) {
                    if (this.bank.accountOwner === item.name) {
                        this.preselectedBank = item;
                    }
                }
                for (let item of this.accountTypes) {
                    if (this.bank.accountType === item.id) {
                        this.preselectedAccountType = item;
                    }
                }
                $("#bank-modal").modal("show");
            },
            onModalButtonClicked() {
                this.params.mode = 'create';
                this.bank = {
                    branchName: "",
                    branchCode: "",
                    kartNumber: "",
                    shebaCode: "",
                    accountType: "",
                    accountNumber: "",
                    description: "",
                    outSourceName: "بانک",
                    accountOwner: "",
                    type: 1
                };
                this.preselectedBank = {};
                this.preselectedAccountType = {};
                this.bank.type = 1;
            },
            onModalOk() {
                if (this.params.mode === 'create') {
                    console.log(this.bank)
                    if (this.bank.accountOwner === null || this.bank.accountOwner === '' || this.bank.accountOwner === undefined) {
                        Utils.handleErrorWithNotification("لطفا بانک را وارد کنید", this.$noty);
                    } else if (this.bank.branchName === null || this.bank.branchName === '' || this.bank.branchName === undefined) {
                        Utils.handleErrorWithNotification("لطفا نام شعبه را وارد کنید", this.$noty);
                    } else if (this.bank.accountType === null || this.bank.accountType === '' || this.bank.accountType === undefined) {
                        Utils.handleErrorWithNotification("لطفا نوع حساب را وارد کنید", this.$noty);
                    } else if (this.bank.accountNumber === null || this.bank.accountNumber === '' || this.bank.accountNumber === undefined) {
                        Utils.handleErrorWithNotification("لطفا شماره حساب را وارد کنید", this.$noty);
                    } else {
                        this.onCreate(this.bank);
                    }
                } else {
                    this.onUpdate(this.bank);
                }
            },
            onBankChange(e) {
                this.bank.accountOwner = e.name;
            },
            onAccountTypeChange(e) {
                this.bank.accountType = e.id;
            },
            onCreate(bank) {
                if (!this.isSending) {
                    this.isSending = true;
                    bank.rowVersion = this.generateUuid();
                    this.bank.outSourceName = this.bank.accountOwner;
                    console.log(this.bank)
                    new BaseService('outsource').create(bank).then(response => {
                        this.$noty.success("حساب بانکی با موفقیت افزوده شد.");
                        $("#bank-modal").modal("hide");
                        this.queryParams.pageIndex = 0;
                        new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                            this.banks = response.data.data;
                            $("#loading").hide();
                            Utils.resetObject(this.bank);
                            this.preselectedBank = {};
                            this.preselectedAccountType = {};
                            this.provider.type = 1;
                        }).catch(error => {
                            console.log(error);
                            Utils.handleErrorWithNotification(error.message, this.$noty);
                        });
                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.data.message, this.$noty);
                    });
                }
            },
            onUpdate(bank) {
                bank.categoryId = 0;
                new BaseService('outsource').update(bank).then(response => {
                    this.$noty.success("حساب بانکی با موفقیت ویرایش شد.");
                    $("#bank-modal").modal("hide");
                    this.queryParams.pageIndex = 0;
                    new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                        this.banks = response.data.data;
                        $("#loading").hide();
                        Utils.resetObject(this.bank);
                        this.preselectedBank = {};
                        this.preselectedAccountType = {};
                        this.provider.type = 1;
                    }).catch(error => {
                        // error
                        Utils.handleErrorWithNotification(error.message, this.$noty);
                    });
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onTransactionModalClicked() {
                $("#transactionModal").modal('show');
                this.transactionsQuery.code = this.bank.code;
                new BaseService('reports', '/gettransactionreport').getList(this.transactionsQuery).then(response => {
                    this.transactions = response.data.data;
                    this.transactionCount = response.data.count;
                    if (this.transactions !== undefined) {
                        for (let item of this.transactions) {
                            item.persianDate = Moment(item.date, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                        }
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            getTransactions() {
                this.transactionsQuery.pageIndex++;
                new BaseService('reports', '/gettransactionreport').getList(this.transactionsQuery).then(response => {
                    this.transactions.push.apply(this.transactions, response.data.data);
                    for (let item of this.transactions) {
                        item.persianDate = Moment(item.date, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            deleteItem() {
                if (confirm("آیا از حذف اطمینان دارید؟")) {
                    if (!this.isSending) {
                        this.isSending = true;
                        console.log(this.bank)
                        new BaseService('outsource').delete(this.bank.id).then(response => {
                            this.$noty.success("حساب بانکی با موفقیت حذف شد.");
                            $("#bank-modal").modal("hide");
                            this.queryParams.pageIndex = 0;
                            new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                                this.banks = response.data.data;
                                $("#loading").hide();
                                Utils.resetObject(this.bank);
                                this.preselectedBank = {};
                                this.preselectedAccountType = {};
                                this.provider.type = 1;
                            }).catch(error => {
                                console.log(error);
                                Utils.handleErrorWithNotification(error.message, this.$noty);
                            });
                            this.isSending = false;
                        }).catch(error => {
                            this.isSending = false;
                            this.$noty.error(error.data.message);
                            Utils.handleErrorWithNotification(error.data.message, this.$noty);
                        });
                    }
                }
            },
        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#bank-modal").hasClass("show")) {
                $("#bank-modal").modal("hide");
                next(false);
            } else {
                if ($("#transactionModal").hasClass("show")) {
                    $("#transactionModal").modal("hide");

                    next(false);
                } else {
                    next();
                }
            }


        },
    }
</script>